import React, {useCallback, useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import ProductCard from "../components/ProductCard";
import StarRating from "../components/StarRating";
import {getProducts, getCategories, getFeaturedReviews} from "../api";
import banner from "../assets/banner.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import pen from "../assets/productBanners/categoryBanners/pen-stand.jpeg";
import actionFigure from "../assets/productBanners/categoryBanners/actionfigure.jpeg";
import car from "../assets/productBanners/categoryBanners/car.jpeg";
import flowerPot from "../assets/productBanners/categoryBanners/flowerpot.jpeg";
import keychain from "../assets/productBanners/categoryBanners/keychain.jpeg";
import puzzle from "../assets/productBanners/categoryBanners/pupzzle.jpeg";
import gift from "../assets/productBanners/categoryBanners/gift.jpeg";
import toy from "../assets/productBanners/categoryBanners/toy.jpeg";
import customized from "../assets/productBanners/categoryBanners/customized.jpeg";

import "./Home.css";
import AnnouncementBar from "../components/AnnouncementBar";

const PERKS = [
  "🚚 Free shipping on orders above ₹699",
  "💸 10% off on orders above ₹1,999",
  "🎁 Surprise gift on orders above ₹3,999",
];

const HERO_BANNERS = [
  {
    src: banner,
    alt: "Elevate Your Space — Premium 3D Printed Home Décor & Accessories",
  },
  {src: banner2, alt: "Handcrafted 3D Printed Designs for Every Room"},
  // {src: banner3, alt: "New Arrivals — Shop the Latest 3D Printed Collection"},
];

export default function Home() {
  const navigate = useNavigate();

  const [bestsellers, setBestsellers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [heroIndex, setHeroIndex] = useState(0);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const timer = setInterval(() => {
      setHeroIndex((i) => (i + 1) % HERO_BANNERS.length);
    }, 4500);
    return () => clearInterval(timer);
  }, []);

  const fetchBestsellers = useCallback(() => {
    setLoading(true);
    getProducts({bestseller: true, limit: 8})
      .then((r) => setBestsellers(r.data.products))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchBestsellers();
  }, [fetchBestsellers]);

  useEffect(() => {
    getCategories()
      .then((r) => {
        const sortedCategories = [...r.data].sort((a, b) => a.order - b.order);
        setCategories(sortedCategories);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    getFeaturedReviews(6)
      .then((r) => setTestimonials(r.data))
      .catch(() => {});
  }, []);

  return (
    <div className="home">
      {/* ── Banner Hero ── */}
      <section className="hero-banner">
        <Link to="/products" className="hero-link">
          {HERO_BANNERS.map((b, i) => (
            <img
              key={b.src}
              src={b.src}
              alt={b.alt}
              className={`hero-banner-img${i === heroIndex ? " active" : ""}`}
            />
          ))}
        </Link>
        <div className="hero-dots">
          {HERO_BANNERS.map((b, i) => (
            <button
              key={b.src}
              type="button"
              className={`hero-dot${i === heroIndex ? " active" : ""}`}
              aria-label={`Show banner ${i + 1}`}
              onClick={(e) => {
                e.preventDefault();
                setHeroIndex(i);
              }}
            />
          ))}
        </div>
      </section>

      {/* Perks strip */}
      <div className="perks-bar" style={{background: "var(--brand90)"}}>
        <AnnouncementBar messages={PERKS} textColor={"black"} />
        {/* {PERKS.map((p, i) => (
          <div className/="perk" key={p}>
            {i > 0 && <span className="perk-sep">/</span>}
            <span className="perk-label">{p}</span>
          </div>
        ))} */}
      </div>

      {/* Shop by Category */}
      <section className="section cat-section">
        <div className="cat-header">
          <p className="section-eyebrow">Curated Collections</p>
          <h2 className="cat-title">Shop by Category</h2>
        </div>

        <div className="cat-grid">
          {categories.map((cat) => {
            console.log("fload", categories);

            let category = cat.slug;
            let categoryBanner;
            if (category === "pen-stand-for-desk") categoryBanner = pen;
            if (category === "action-figure") categoryBanner = actionFigure;
            if (category === "car-dashbord") categoryBanner = car;
            if (category === "flower-pots") categoryBanner = flowerPot;
            if (category === "key-chain" || category === "keychains")
              categoryBanner = keychain;
            if (category === "puzzle") categoryBanner = puzzle;
            if (category === "all") categoryBanner = toy;
            if (category === "Gift" || category === "gifts")
              categoryBanner = gift;
            if (category === "customized-product") categoryBanner = customized;

            return (
              <div
                key={cat._id}
                className="cat-card"
                onClick={() => navigate(`/products?category=${cat._id}`)}
              >
                <div className="cat-img-wrap">
                  {categoryBanner ? (
                    <img
                      src={categoryBanner}
                      alt={cat.name}
                      className="cat-img"
                    />
                  ) : (
                    <div className="cat-img cat-img-placeholder">
                      <span className="cat-placeholder-name">{cat.name}</span>
                    </div>
                  )}

                  <button
                    className="cat-btn"
                    aria-label={`Shop ${cat.name}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/products?category=${cat._id}`);
                    }}
                  >
                    Shop now <span className="cat-btn-arrow">→</span>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Bestsellers */}
      <section className="section bg-light">
        <div className="section-header">
          <div>
            <p className="section-eyebrow">Fan Favourites</p>
            <h2 className="section-title">Bestsellers</h2>
          </div>
          <Link to="/products?bestseller=true" className="see-all">
            See all →
          </Link>
        </div>
        {loading ? (
          <div className="loading-grid grid grid-4">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="skeleton-card" />
            ))}
          </div>
        ) : bestsellers.length > 0 ? (
          <div className="grid grid-4">
            {bestsellers.map((p) => (
              <ProductCard key={p._id} product={p} />
            ))}
          </div>
        ) : (
          <p className="empty-hint">
            New bestsellers are on their way — check back soon.
          </p>
        )}
      </section>

      {/* Testimonials — only rendered once there are real 4★+ reviews */}
      {testimonials.length > 0 && (
        <section className="section testimonials">
          <div className="cat-header">
            <p className="section-eyebrow">Real Reviews</p>
            <h2 className="cat-title">Loved by Our Customers</h2>
          </div>
          <div className="testi-row">
            {testimonials.map((t) => {
              const img =
                t.product.images?.find((i) => i.isPrimary) ||
                t.product.images?.[0];
              return (
                <figure key={t._id} className="testi-card">
                  <StarRating value={t.rating} size={15} />
                  {t.title && <h3 className="testi-title">{t.title}</h3>}
                  <blockquote className="testi-body">{t.body}</blockquote>
                  <figcaption className="testi-foot">
                    <span className="testi-name">
                      {t.name}
                      {t.verified && (
                        <span className="testi-verified">Verified buyer</span>
                      )}
                    </span>
                    <Link
                      to={`/products/${t.product.slug || t.product._id}`}
                      className="testi-product"
                    >
                      {img && <img src={img.url} alt="" loading="lazy" />}
                      <span>{t.product.name}</span>
                    </Link>
                  </figcaption>
                </figure>
              );
            })}
          </div>
        </section>
      )}
    </div>
  );
}
